import { createSlice } from '@reduxjs/toolkit';
import VwStkDepodonemDTO from 'src/models/StokEczane/DepoDonemleri/VwStkDepodonemDTO';
import StkDepoTanimDTO from 'src/models/StokEczane/DepoTanimlari/StkDepoTanimDTO';
import VwServisdepolistDTO from 'src/models/StokEczane/DepoTanimlari/VwServisdepolistDTO';
import VwStkDepotanimsorguDTO from 'src/models/StokEczane/DepoTanimlari/VwStkDepotanimsorguDTO ';
import WareHourseQueryRequest from 'src/models/StokEczane/DepoTanimlari/WareHouseQueryRequest';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import { depoTanimApi } from 'src/services/StokEczane/DepotanimApi';

interface IDepoTanimState {
  searchModel: WareHourseQueryRequest;
  searchFormSubmit: boolean;
  wareHouseList: Array<VwStkDepotanimsorguDTO>;
  depoTanimId: number;
  isDepoSecimDialogOpen: boolean;
  selectedDepo: VwStkDepodonemDTO;
  servisDepoList: Array<VwServisdepolistDTO>;
}

const DepoTanimSlice = createSlice<
  IDepoTanimState,
  MapReducerPayloads<
    IDepoTanimState,
    {
      setState: IDepoTanimState;
      setDepoTanimSearchState: WareHourseQueryRequest;
      setSearchFormSubmit: boolean;
      setWareHouseList: Array<StkDepoTanimDTO>;
      setDepoTanimId: number;
      setIsDepoSecimDialogOpen: boolean;
      setSelectedDepo: VwStkDepodonemDTO;
      setServisDepoList: Array<VwServisdepolistDTO>;
    }
  >
>({
  name: 'DepoTanim',
  initialState: {
    searchModel: new WareHourseQueryRequest(),
    searchFormSubmit: true,
    wareHouseList: new Array<StkDepoTanimDTO>(),
    depoTanimId: null,
    isDepoSecimDialogOpen:false,
    selectedDepo:new VwStkDepodonemDTO(),
    servisDepoList: new Array<VwServisdepolistDTO>()
  },
  reducers: {
    setState: (state, action) => action.payload,
    setDepoTanimSearchState: (state, action) => {
      state.searchModel = action.payload;
    },
    setSearchFormSubmit: (state, action) => {
      state.searchFormSubmit = action.payload;
    },
    setWareHouseList: (state, action) => {
      state.wareHouseList = action.payload;
    },
    setDepoTanimId: (state, action) => {
      state.depoTanimId = action.payload;
    },
    setIsDepoSecimDialogOpen:(state,action)=>{
      state.isDepoSecimDialogOpen=action.payload;
    },
    setSelectedDepo:(state,action)=>{
      state.selectedDepo=action.payload;
    },
    setServisDepoList:(state,action) => {
      state.servisDepoList = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(depoTanimApi.endpoints.GetServisDepoList.matchFulfilled, (state, action) => {
      return {
        ...state,
        servisDepoList: action.payload
      };
    })
  }
});

export default DepoTanimSlice;
